// @flow
import { connect } from 'react-redux';
import type { State } from '../../../../../types';
import { configSelector } from '../../../../../selectors/configSelectors';
import ConfigItem from '../ConfigItem';
import type { Props } from '../ConfigItem';

const mapStateToProps = (state: State) => {
    return {
        config: configSelector(state)
    };
};

export default connect<Props, _, _, _, _, _>(mapStateToProps)(ConfigItem);